/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BackOfficeApiKeyCreateRequest,
  BackOfficeApiKeyCreateResponse,
  BackOfficeApiKeyLookupRequest,
  BackOfficeApiKeyRecord,
  BackOfficeApiKeyRotateRequest,
  BackOfficeApiKeyScopeUsageRecord,
  BackOfficeApiKeyUpdateRequest,
  ErrorResponse,
  ServiceName,
} from '../models/index';
import {
    BackOfficeApiKeyCreateRequestFromJSON,
    BackOfficeApiKeyCreateRequestToJSON,
    BackOfficeApiKeyCreateResponseFromJSON,
    BackOfficeApiKeyCreateResponseToJSON,
    BackOfficeApiKeyLookupRequestFromJSON,
    BackOfficeApiKeyLookupRequestToJSON,
    BackOfficeApiKeyRecordFromJSON,
    BackOfficeApiKeyRecordToJSON,
    BackOfficeApiKeyRotateRequestFromJSON,
    BackOfficeApiKeyRotateRequestToJSON,
    BackOfficeApiKeyScopeUsageRecordFromJSON,
    BackOfficeApiKeyScopeUsageRecordToJSON,
    BackOfficeApiKeyUpdateRequestFromJSON,
    BackOfficeApiKeyUpdateRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ServiceNameFromJSON,
    ServiceNameToJSON,
} from '../models/index';

export interface CreateBackOfficeApiKeyRequest {
    customerId: string;
    backOfficeApiKeyCreateRequest: BackOfficeApiKeyCreateRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface DeleteBackOfficeApiKeyRequest {
    customerId: string;
    keyId: string;
    service: ServiceName;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetApiKeyScopeUsageRequest {
    customerId: string;
    keyId: string;
    service: ServiceName;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetBackOfficeApiKeyRequest {
    customerId: string;
    keyId: string;
    service: ServiceName;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetServiceScopesRequest {
    customerId: string;
    service: ServiceName;
    xClientID?: string;
    xRequestID?: string;
}

export interface ListAllApiKeysRequest {
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface LookupBackOfficeApiKeyRequest {
    customerId: string;
    backOfficeApiKeyLookupRequest: BackOfficeApiKeyLookupRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface RotateBackOfficeApiKeyRequest {
    customerId: string;
    keyId: string;
    backOfficeApiKeyRotateRequest: BackOfficeApiKeyRotateRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface UpdateBackOfficeApiKeyRequest {
    customerId: string;
    keyId: string;
    backOfficeApiKeyUpdateRequest: BackOfficeApiKeyUpdateRequest;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class APIKeysApi extends runtime.BaseAPI {

    /**
     * Create a new API key. The encoded key is returned once and cannot be retrieved again.
     */
    async createBackOfficeApiKeyRaw(requestParameters: CreateBackOfficeApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BackOfficeApiKeyCreateResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling createBackOfficeApiKey().'
            );
        }

        if (requestParameters['backOfficeApiKeyCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'backOfficeApiKeyCreateRequest',
                'Required parameter "backOfficeApiKeyCreateRequest" was null or undefined when calling createBackOfficeApiKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:api_keys"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/api-keys`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BackOfficeApiKeyCreateRequestToJSON(requestParameters['backOfficeApiKeyCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BackOfficeApiKeyCreateResponseFromJSON(jsonValue));
    }

    /**
     * Create a new API key. The encoded key is returned once and cannot be retrieved again.
     */
    async createBackOfficeApiKey(requestParameters: CreateBackOfficeApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BackOfficeApiKeyCreateResponse> {
        const response = await this.createBackOfficeApiKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an API key permanently
     */
    async deleteBackOfficeApiKeyRaw(requestParameters: DeleteBackOfficeApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling deleteBackOfficeApiKey().'
            );
        }

        if (requestParameters['keyId'] == null) {
            throw new runtime.RequiredError(
                'keyId',
                'Required parameter "keyId" was null or undefined when calling deleteBackOfficeApiKey().'
            );
        }

        if (requestParameters['service'] == null) {
            throw new runtime.RequiredError(
                'service',
                'Required parameter "service" was null or undefined when calling deleteBackOfficeApiKey().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['service'] != null) {
            queryParameters['service'] = requestParameters['service'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:api_keys"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/api-keys/{keyId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"keyId"}}`, encodeURIComponent(String(requestParameters['keyId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an API key permanently
     */
    async deleteBackOfficeApiKey(requestParameters: DeleteBackOfficeApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteBackOfficeApiKeyRaw(requestParameters, initOverrides);
    }

    /**
     * Get scope usage records for an API key
     */
    async getApiKeyScopeUsageRaw(requestParameters: GetApiKeyScopeUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BackOfficeApiKeyScopeUsageRecord>>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getApiKeyScopeUsage().'
            );
        }

        if (requestParameters['keyId'] == null) {
            throw new runtime.RequiredError(
                'keyId',
                'Required parameter "keyId" was null or undefined when calling getApiKeyScopeUsage().'
            );
        }

        if (requestParameters['service'] == null) {
            throw new runtime.RequiredError(
                'service',
                'Required parameter "service" was null or undefined when calling getApiKeyScopeUsage().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['service'] != null) {
            queryParameters['service'] = requestParameters['service'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:api_keys"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/api-keys/{keyId}/scope-usage`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"keyId"}}`, encodeURIComponent(String(requestParameters['keyId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BackOfficeApiKeyScopeUsageRecordFromJSON));
    }

    /**
     * Get scope usage records for an API key
     */
    async getApiKeyScopeUsage(requestParameters: GetApiKeyScopeUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BackOfficeApiKeyScopeUsageRecord>> {
        const response = await this.getApiKeyScopeUsageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a single API key by ID
     */
    async getBackOfficeApiKeyRaw(requestParameters: GetBackOfficeApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BackOfficeApiKeyRecord>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getBackOfficeApiKey().'
            );
        }

        if (requestParameters['keyId'] == null) {
            throw new runtime.RequiredError(
                'keyId',
                'Required parameter "keyId" was null or undefined when calling getBackOfficeApiKey().'
            );
        }

        if (requestParameters['service'] == null) {
            throw new runtime.RequiredError(
                'service',
                'Required parameter "service" was null or undefined when calling getBackOfficeApiKey().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['service'] != null) {
            queryParameters['service'] = requestParameters['service'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:api_keys"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/api-keys/{keyId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"keyId"}}`, encodeURIComponent(String(requestParameters['keyId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BackOfficeApiKeyRecordFromJSON(jsonValue));
    }

    /**
     * Get a single API key by ID
     */
    async getBackOfficeApiKey(requestParameters: GetBackOfficeApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BackOfficeApiKeyRecord> {
        const response = await this.getBackOfficeApiKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get available scopes for a specific service
     */
    async getServiceScopesRaw(requestParameters: GetServiceScopesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getServiceScopes().'
            );
        }

        if (requestParameters['service'] == null) {
            throw new runtime.RequiredError(
                'service',
                'Required parameter "service" was null or undefined when calling getServiceScopes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['service'] != null) {
            queryParameters['service'] = requestParameters['service'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:api_keys"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/api-keys/scopes`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get available scopes for a specific service
     */
    async getServiceScopes(requestParameters: GetServiceScopesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getServiceScopesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all API keys across GDS and PDS
     */
    async listAllApiKeysRaw(requestParameters: ListAllApiKeysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BackOfficeApiKeyRecord>>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling listAllApiKeys().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:api_keys"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/api-keys`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BackOfficeApiKeyRecordFromJSON));
    }

    /**
     * List all API keys across GDS and PDS
     */
    async listAllApiKeys(requestParameters: ListAllApiKeysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BackOfficeApiKeyRecord>> {
        const response = await this.listAllApiKeysRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Look up an API key by its encoded value. Tries GDS first, then PDS.
     */
    async lookupBackOfficeApiKeyRaw(requestParameters: LookupBackOfficeApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BackOfficeApiKeyRecord>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling lookupBackOfficeApiKey().'
            );
        }

        if (requestParameters['backOfficeApiKeyLookupRequest'] == null) {
            throw new runtime.RequiredError(
                'backOfficeApiKeyLookupRequest',
                'Required parameter "backOfficeApiKeyLookupRequest" was null or undefined when calling lookupBackOfficeApiKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:api_keys"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/api-keys/lookup`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BackOfficeApiKeyLookupRequestToJSON(requestParameters['backOfficeApiKeyLookupRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BackOfficeApiKeyRecordFromJSON(jsonValue));
    }

    /**
     * Look up an API key by its encoded value. Tries GDS first, then PDS.
     */
    async lookupBackOfficeApiKey(requestParameters: LookupBackOfficeApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BackOfficeApiKeyRecord> {
        const response = await this.lookupBackOfficeApiKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Rotate an API key - generates a new key value, immediately invalidating the old one
     */
    async rotateBackOfficeApiKeyRaw(requestParameters: RotateBackOfficeApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BackOfficeApiKeyCreateResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling rotateBackOfficeApiKey().'
            );
        }

        if (requestParameters['keyId'] == null) {
            throw new runtime.RequiredError(
                'keyId',
                'Required parameter "keyId" was null or undefined when calling rotateBackOfficeApiKey().'
            );
        }

        if (requestParameters['backOfficeApiKeyRotateRequest'] == null) {
            throw new runtime.RequiredError(
                'backOfficeApiKeyRotateRequest',
                'Required parameter "backOfficeApiKeyRotateRequest" was null or undefined when calling rotateBackOfficeApiKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:api_keys"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/api-keys/{keyId}/rotate`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"keyId"}}`, encodeURIComponent(String(requestParameters['keyId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BackOfficeApiKeyRotateRequestToJSON(requestParameters['backOfficeApiKeyRotateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BackOfficeApiKeyCreateResponseFromJSON(jsonValue));
    }

    /**
     * Rotate an API key - generates a new key value, immediately invalidating the old one
     */
    async rotateBackOfficeApiKey(requestParameters: RotateBackOfficeApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BackOfficeApiKeyCreateResponse> {
        const response = await this.rotateBackOfficeApiKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an API key\'s description, scopes, or active status
     */
    async updateBackOfficeApiKeyRaw(requestParameters: UpdateBackOfficeApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BackOfficeApiKeyRecord>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling updateBackOfficeApiKey().'
            );
        }

        if (requestParameters['keyId'] == null) {
            throw new runtime.RequiredError(
                'keyId',
                'Required parameter "keyId" was null or undefined when calling updateBackOfficeApiKey().'
            );
        }

        if (requestParameters['backOfficeApiKeyUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'backOfficeApiKeyUpdateRequest',
                'Required parameter "backOfficeApiKeyUpdateRequest" was null or undefined when calling updateBackOfficeApiKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:api_keys"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/api-keys/{keyId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"keyId"}}`, encodeURIComponent(String(requestParameters['keyId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BackOfficeApiKeyUpdateRequestToJSON(requestParameters['backOfficeApiKeyUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BackOfficeApiKeyRecordFromJSON(jsonValue));
    }

    /**
     * Update an API key\'s description, scopes, or active status
     */
    async updateBackOfficeApiKey(requestParameters: UpdateBackOfficeApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BackOfficeApiKeyRecord> {
        const response = await this.updateBackOfficeApiKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
